module.exports = __webpack_public_path__ + "static/spinner-4f97249e3ac34700f7d3c485cfe97a17.gif";